/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1SalesNotesUsersUserIdPatchRequestAllOf model module.
 * @module model/AgentV1SalesNotesUsersUserIdPatchRequestAllOf
 * @version 1.0.0
 */
class AgentV1SalesNotesUsersUserIdPatchRequestAllOf {
    /**
     * Constructs a new <code>AgentV1SalesNotesUsersUserIdPatchRequestAllOf</code>.
     * @alias module:model/AgentV1SalesNotesUsersUserIdPatchRequestAllOf
     */
    constructor() { 
        
        AgentV1SalesNotesUsersUserIdPatchRequestAllOf.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1SalesNotesUsersUserIdPatchRequestAllOf</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1SalesNotesUsersUserIdPatchRequestAllOf} obj Optional instance to populate.
     * @return {module:model/AgentV1SalesNotesUsersUserIdPatchRequestAllOf} The populated <code>AgentV1SalesNotesUsersUserIdPatchRequestAllOf</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1SalesNotesUsersUserIdPatchRequestAllOf();

            if (data.hasOwnProperty('last_sales_note_updated_at')) {
                obj['last_sales_note_updated_at'] = ApiClient.convertToType(data['last_sales_note_updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1SalesNotesUsersUserIdPatchRequestAllOf</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1SalesNotesUsersUserIdPatchRequestAllOf</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * 楽観的排他制御用。クライアントが保持している最終更新日時。DBの値と一致しない場合は409を返す。
 * @member {Date} last_sales_note_updated_at
 */
AgentV1SalesNotesUsersUserIdPatchRequestAllOf.prototype['last_sales_note_updated_at'] = undefined;






export default AgentV1SalesNotesUsersUserIdPatchRequestAllOf;

